module.exports = __webpack_public_path__ + "media/images/quick_search/format/img_mobile_3-f43b38f47351ac0c2281601637db5c2f.png";